import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "onChange", "options", "disabled", "disabledText", "valueKey", "values"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @class MultiPicker
 *
 */
import { has, isArray, isObject, pluck } from 'underscore';
import PropTypes from 'prop-types';
import React from 'react';
import Select from './select';
const MultiPicker = _ref => {
  let _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    onChange = _ref.onChange,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$disabledText = _ref.disabledText,
    disabledText = _ref$disabledText === void 0 ? '' : _ref$disabledText,
    _ref$valueKey = _ref.valueKey,
    valueKey = _ref$valueKey === void 0 ? 'id' : _ref$valueKey,
    _ref$values = _ref.values,
    values = _ref$values === void 0 ? [] : _ref$values,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  /**
   *  @function handleChange - strip className attribute from changed values
   */
  const handleChange = incomingValues => {
    const handleChangeValues = (incomingValues || []).map(val => {
      const result = JSON.parse(JSON.stringify(val));
      if (has(result, 'className')) {
        delete result.className;
      }
      return result;
    });
    onChange(handleChangeValues);
  };

  /**
  * @function prepareValues  - prepare a list of single primitive values, e.g. ID strings
  */
  const prepareValues = () => {
    let result = values;
    if (isArray(values)) {
      if (values.length > 0 && isObject(values[0])) {
        result = pluck(values, valueKey);
      }
    }
    return result;
  };
  const selectProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    values: prepareValues(),
    multi: true,
    onChange: handleChange,
    className: "".concat(className, " t-sp"),
    options,
    disabled,
    disabledText,
    valueKey
  });
  return /*#__PURE__*/React.createElement(Select, selectProps);
};
MultiPicker.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  disabledText: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  valueKey: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.object]))
};
export default MultiPicker;